import { Link } from "react-router-dom";
import { tickerItems } from "@/mocks/posts";

export default function NewsTicker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center gap-4 h-11">
          <span className="flex items-center gap-1.5 shrink-0 text-xs font-bold text-accent-300">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-soft-pulse"></span>
            正在吃瓜
          </span>
          <div className="ticker-mask flex-1 overflow-hidden">
            <div className="flex items-center gap-8 w-max animate-ticker-move">
              {loop.map((item, index) => (
                <Link
                  key={`${item}-${index}`}
                  to="/breaking"
                  className="text-sm text-background-100 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}